<!--Footer Starts-->
<footer class="footer">
  <p class="copyright clearfix text-muted m-0">
    Created by &copy; {{currentDate | date: 'yyyy'}} <a id="pixinventLink"
      href="https://www.ideaurum.com/">Ideaurum Development</a>
    <span class="d-none d-sm-inline-block">.</span>
  </p>
</footer>
<!--Footer Ends-->
